import {Component, input} from '@angular/core';

@Component({
  selector: 'confirmation-modal',
  imports: [],
  templateUrl: './confirmation-modal.html',
  styleUrl: './confirmation-modal.scss',
})
export class ConfirmationModal {
  public textModal = input<string>('');
  public subTextModal = input<string>('')
  public typeImage = input<'lastLesson' | 'testNotFinished'  | 'succsessAnketa' | null>(null);

}
